var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h-full flex flex-col"},[_c('v-card',{attrs:{"color":"grey lighten-4","flat":"","tile":""}},[_c('toolbar')],1),_c('div',{staticClass:"flex flex-col",class:!_vm.top ? 'justify-center text-center' : 'mt-8'},[_vm._t("default")],2),_c('bottom-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }